//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _inventory from './inventory';
export const inventory = _inventory;
export default {inventory};

